<template>
	<div>
		<div class="p-d-flex p-flex-column p-ai-center">
			<i class="pi pi-check-circle" style="font-size: 3rem; color: green"></i>
			<h2 class="p-text-center titleFont p-pt-2 p-text-bold">
				Thank You For Your Payment
			</h2>

			<table
				class="p-d-flex p-text-left p-jc-center"
				style="line-height: 1.4rem"
			>
				<tbody>
					<tr>
						<td>Status</td>
						<td class="p-pl-5">
							{{ store.formSubmissionData.status }}
						</td>
					</tr>

					<tr v-if="store.formSubmissionData.merchantId">
						<td>Transaction ID</td>
						<td class="p-pl-5">{{ store.formSubmissionData.merchantId }}</td>
					</tr>

					<tr>
						<td>Total Amount</td>
						<td class="p-pl-5">
							${{
								store.S1FormData.totalOfAllStudents != undefined
									? store.S1FormData.totalOfAllStudents.toFixed(2)
									: 0
							}}
						</td>
					</tr>

					<!-- <tr>
            <td>Student Name</td>
            <td class="p-pl-5">{{ store.S1FormData.firstName }}</td>
          </tr>

          <tr v-show="store.S1FormData.frequency != 'One Time'">
            <td>Start Date</td>
            <td class="p-pl-5">{{ store.S1FormData.formattedStartDate }}</td>
          </tr> -->
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
import { useFormDataStore } from "../../store/formData.js";

export default {
	name: "EndForm",
	setup() {
		const store = useFormDataStore();

		return {
			store,
		};
	},
};
</script>

<style lang="scss" scoped>
.titleFont {
	font-size: 1.9rem;
}
</style>
